import { render, staticRenderFns } from "./CompraMensagem.vue?vue&type=template&id=1fcfadd0"
import script from "./CompraMensagem.vue?vue&type=script&lang=js"
export * from "./CompraMensagem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports